import {Elements} from "@stripe/react-stripe-js";
import {
    loadStripe,
    StripeElementsOptions
} from "@stripe/stripe-js";
import config from "../../../config";
import {PaymentIntent} from "../../payment-intents/types.ts";
import {RecordForm} from "../forms/RecordForm.tsx";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(config.stripe.publishableKey);

export const AddPage = ({paymentIntent}: { paymentIntent: PaymentIntent }) => {

    const options = {
        // passing the client secret obtained from the server
        // clientSecret: '{{CLIENT_SECRET}}',
        clientSecret: paymentIntent.clientSecret,
        appearance: {
            theme: 'stripe',
            // theme: 'night',
            // theme: 'flat',
            rules: {
                '.Input': {
                    border: '1px solid #E0E6EB',
                }
            }
        }
    } as StripeElementsOptions;


    return (
        <Elements stripe={stripePromise} options={options}>
            <RecordForm/>
        </Elements>

    )
}